import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { roleTypeOperator, roleTypeSap } from "src/_constants/roleType";
import { MatSort, MatTableDataSource } from "@angular/material";

@Component({
  selector: "app-crm-events",
  templateUrl: "./crm-events.component.html",
  styleUrls: ["./crm-events.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CrmEventsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  public userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));

  public ForOP = roleTypeOperator.includes(this.userInfo.role);
  public ForSAP = roleTypeSap.includes(this.userInfo.role);
  ProviderId: string = "";
  sportsList = [];
  eventsList = new MatTableDataSource<any>();
  searchKey = "";
  sportId;
  sportName: string = "";

  eventsTableColumns = ["Open Date", "EventId", "Event Name"];
  constructor(
    private appService: AppService,
    private router: Router,
    private activetedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.ProviderId = "SportRadar";
    this.activetedRoute.queryParams.subscribe((params) => {
      this.sportId = params["sportId"];
      this.sportName = params["sportName"];
    });
    this.getSportsByProvider(this.ProviderId);
    if (this.ProviderId && this.sportId) {
      this.getEvents();
    }
  }

  ngAfterViewInit() {
    this.eventsList.sort = this.sort;
    this.eventsList.sortingDataAccessor = (item, property) => {
      switch (property) {
        case "Event Name":
          return item.eventName;
        case "Open Date":
          return item.openDate;
        case "EventId":
          return item.eventId;
        default:
          return item[property];
      }
    };
  }

  onSelectedSportName(Sport) {
    this.eventsList.data = [];
    this.sportName = Sport.SportName;
    this.sportId = Sport.SportId;
    this.getEvents();
  }

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportData(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sportsList = res.sports;
        }
      });
    } catch (err) { }
  }

  searchHandlerChange() {
    this.eventsList.filter = this.searchKey;
  }

  getEvents() {
    try {
      let filters = {
        providerId: this.ProviderId,
        sportId: this.sportId,
      };
      this.appService.getPremiumEvents(filters).subscribe((response) => {
        if (response.status === "RS_OK") {
          this.eventsList.data = response.events.sort(
            (a, b) => b.openDate - a.openDate
          );
        } else {
          this.appService.openErrorBar(response.errorDescription);
        }
      });
    } catch (err) {
      console.log(err);
    }
  }

  goToMarketsPage(event) {
    this.router.navigate(["catalog/catalog-mapping-markets"], {
      queryParams: {
        providerId: this.ProviderId,
        sportId: this.sportId,
        eventId: event.eventId,
        eventName: event.eventName,
        sportName: this.sportName,
        openDate: event.openDate,
      },
    });
  }

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }
}
